// extracted by mini-css-extract-plugin
module.exports = {"LevelUp":"LevelUp_LevelUp__CpKzg","Img":"LevelUp_Img__128EO","Btn":"LevelUp_Btn__3Yalc"};